export const TextFragment = ({ fragment: { id, style, text } }) =>
  id || style ? (
    <span tabIndex={-1} id={id} style={style}>
      {text}
    </span>
  ) : (
    text
  );
